import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroPillars } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-79" data-mp="9k0b6xwjpxkw">
      <div className="mx-auto max-w-4xl px-5 pb-6 text-center" style={{
      paddingTop: "0px"
    }} data-id="element-80" data-mp="4lqkazhutj53">
        <h1 className="mx-auto mt-2 max-w-3xl font-display text-[23px] font-black uppercase leading-tight text-plum sm:text-[34px]" style={{
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-81" data-mp="129h2ttccdag2">
          The Professional <span className="text-grape" data-id="element-82" data-mp="sartioyigybf">AI Solution</span> to cut paperwork time by <span className="text-grape" data-id="element-83" data-mp="sd48ct8z2sk9">80%</span>
        </h1>

        <p className="pb-5 pt-3 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-plum/60 sm:text-sm" style={{
        paddingTop: "17px",
        paddingBottom: "10px"
      }} data-id="element-84" data-mp="nbooh4ij6s3g">
          The Practical AI Toolkit for Team Management, Daily Operations, Planning & Professional Reporting in seconds
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-85" data-mp="3j9ahhe4fas5o">
          <img src="https://cdn.magicpatterns.com/uploads/33vxFhDVDggKv2K593ZZ8F/Paquete_Sigma_Smart_para_Supervisores.webp" alt="100+ AI Prompts for Supervisors™ — 6-Volume System + 5 Professional Bonuses by SIGMA SMART™" width={1536} height={1024} sizes="(min-width: 640px) 640px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[640px] object-contain" style={{
          paddingTop: "8px",
          marginTop: "-25px",
          marginBottom: "-25px"
        }} data-id="element-86" data-mp="39cfjqxfz4vsg" />
        </motion.div>

        <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-plum/70 sm:text-base" data-id="element-87" data-mp="2vgu25bc2lea2">
          A structured, ready-to-use prompt system designed to help supervisors organize daily responsibilities, communicate more clearly, prepare professional documentation, and manage recurring tasks with greater consistency.
        </p>

        <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-88" data-mp="nb1ld6kmpvxh">
          100+ AI Prompts · 6-Volume System + 5 Professional Bonuses · The SIGMA SMART™ Method · ⭐ 4.9 (Over 300 Supervisors Satisfied) · ⚡Instant Access · 
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-89" data-mp="dbaq32o8vcwc">
          <CTAButton href="#pricing" data-id="element-90" data-mp="1azkwdtv2cmt9">See the 100+ AI Prompts for Supervisors™ now</CTAButton>

          <p className="mx-auto mt-5 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-91" data-mp="163472wc4o2el">
            <span className="font-bold text-plum" data-id="element-92" data-mp="111y9ak3m1oy7">THE #1 PRACTICAL AI TOOLKIT FOR MODERN SUPERVISORS.</span> Designed for team leaders, shift supervisors, operations supervisors, department coordinators, frontline managers, and professionals responsible for keeping people and processes organized.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-grape-deep sm:text-xl" data-id="element-93" data-mp="3hqk9uf1wzmrs">
            {heroPillars}
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-94" data-mp="1x7htx8b35sy8">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape-soft/50 bg-white px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-95" data-mp="269zfdkix2hk6">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-96" data-mp="2b2snmidlg810" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-97" data-mp="2kyvmnfd5fqjq">
            - Everything you need to organize recurring supervisory tasks in one practical resource -
          </p>
        </div>

        <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-plum px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-grape-soft" data-id="element-98" data-mp="2tzley937aysp">
          🔥 Limited Time Offer · Price will return to $54 soon
        </div>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-plum/50" data-id="element-99" data-mp="zkrawrocbucl">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-100" data-mp="4acmxeox1t8h" />
          15 supervisors are viewing this toolkit right now
        </p>
      </div>
    </header>;
}